const completedStatuses = new Set(['complete', 'skipped']);

export const areAllOnboardingStepsComplete = statuses => (
    Array.isArray(statuses)
    && statuses.length > 0
    && statuses.every(status => completedStatuses.has(status))
);

export const getSavedLicenceFlowStage = (onboardingProgress) => {
    if (!onboardingProgress || typeof onboardingProgress !== 'object') return null;

    const statusByKey = (onboardingProgress.steps || []).reduce((statuses, step) => {
        if (step?.key) statuses[step.key] = step.status;
        return statuses;
    }, {});

    if (!Object.keys(statusByKey).length) {
        return onboardingProgress.overall_status === 'completed' ? 2 : 0;
    }
    if (!completedStatuses.has(statusByKey.licences)) return 0;
    if (!completedStatuses.has(statusByKey.projects)) return 1;
    return 2;
};
